module.exports = __webpack_public_path__ + "img/logo-icoev-header.3837fddb.png";